import * as React from "react";

interface Broadcaster {
  name: string;
  imageUrl: string;
  linkUrl: string;
  platformId: string;
}

interface BroadcasterProps {
  name: string;
  imageUrl: string;
  linkUrl: string;
  note: string;
}

export const Watching = ({
  watching,
  broadcasters,
  broadcastPlatforms
}: any) => {
  const buckets = watching.reduce((sections: object, item: any) => {
    const broadcaster: Broadcaster = broadcasters[item.broadcasterId];
    const platformId = broadcaster.platformId;
    if (!sections[platformId]) sections[platformId] = [];
    sections[platformId] = sections[platformId] || [];
    const broadcasterView: BroadcasterProps = {
      ...broadcaster,
      note: item.note
    };
    sections[broadcaster.platformId].push(
      <Broadcaster key={item.broadcasterId} {...broadcasterView} />
    );
    return sections;
  }, {});

  const sections = Object.keys(buckets).map(key => (
    <WatchingSection key={key} platform={broadcastPlatforms[key]}>
      {buckets[key]}
    </WatchingSection>
  ));

  return (
    <div className="watching">
      <h2>Watching</h2>
      {sections}
    </div>
  );
};

function WatchingSection({ platform, children }: any) {
  return (
    <div className="watching-section">
      <div className="header fb-wrap">
        <img className="link-badge" src={platform.imageUrl} alt="" />
        <h3>{platform.name}</h3>
        <div className="watching-section-divider" />
      </div>
      {children}
    </div>
  );
}

function Broadcaster({ name, note, imageUrl }: BroadcasterProps) {
  return (
    <div className="broadcaster fb-row fb-ac">
      <img src={imageUrl} alt={name + " avatar"} />
      <div className="fb-column">
        <a href="#">{name}</a>
        <span>{note}</span>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Profile/Watching.tsx